import { api } from "../../common/config/api";

export const FEEDBACK_URL = {
   getFeedbacks: `${api.withAPI}/v1/catalog/product/feedback`,
   getFeedback: `${api.withAPI}/v1/catalog/product/feedback`,
   removeFeedback: `${api.withAPI}/v1/catalog/product/feedback`,
   editFeedback: `${api.withAPI}/v1/catalog/product/feedback`,
   getFeedbacksProduct: `${api.withAPI}/v1/catalog/product/feedback`
}
